export default __webpack_public_path__ + "static/media/sb-name.d9af57bf.png";